import { Channel } from 'api/ChannelsAPI';
import { MessageType } from 'api/MessageTypeAPI';
import { EspAccount } from 'modules/graphql/types';
import { createContext, useContext } from 'react';
import { PAGE_SIZES, PaginationUpdateEvent } from 'ui/paginationFooter';
import noop from 'utils/noop';
import { MessageTypesByChannelId } from '../types';

type ChannelsContextType = {
  filteredChannels: Channel[];
  currentChannels: Channel[];
  currentPage: number;
  espAccounts: EspAccount[];
  getEspAccountById: (val: number) => EspAccount | undefined;
  handlePaginationUpdate: (paginationEvent: PaginationUpdateEvent) => void;
  isLoading: boolean;
  itemsPerPage: number;
  messageMedium: string;
  messageTypes: MessageType[];
  messageTypesByChannelId: MessageTypesByChannelId;
  paginatedChannels: Channel[];
  refetchChannels: () => void;
  refetchMessageTypes: () => void;
};

const defaultState = {
  filteredChannels: [],
  currentChannels: [],
  currentPage: 1,
  espAccounts: [],
  getEspAccountById: () => undefined,
  handlePaginationUpdate: noop,
  isLoading: false,
  itemsPerPage: PAGE_SIZES[0],
  messageMedium: '',
  messageTypes: [],
  messageTypesByChannelId: {},
  paginatedChannels: [],
  refetchChannels: noop,
  refetchMessageTypes: noop,
};

export const ChannelsContext = createContext<ChannelsContextType>(defaultState);

export const useChannelsContext = () => useContext<ChannelsContextType>(ChannelsContext);
